/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import * as localForage from 'localforage';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Redirect, Switch, useLocation } from 'react-router-dom';
import { Container, Content } from './component/Containers/Containers';
import NavbarContent from './component/PageComponents/Navbar/Navbar';
import PlayerBarContainer from './component/PageComponents/PlayerBar/PlayerBar';
import SidebarContent from './component/PageComponents/Sidebar/Sidebar';
import About from './pages/About';
import Add from './pages/Add';
import Terms from './pages/Terms';
import Edit from './pages/Edit';
import Privacy from './pages/Privacy';
import Favourites from './pages/Favourites';
import Gestion from './pages/Gestion';
import Home from './pages/Home';
import Login from './pages/Login';
import ManualUsuario from './pages/ManualUsuario';
import ManualUsuario1 from './pages/ManualUsuario1';
import ManualUsuario2 from './pages/ManualUsuario2';
import ManualUsuario3 from './pages/ManualUsuario3';
import ManualUsuario4 from './pages/ManualUsuario4';
import GuardedRoute from './utils/authComponent/GuardedRoute';
import {
  getStations,
  setFavorites,
  setProvince,
} from './store/features/stationSlice';
import { setMenuOpenedState } from './store/features/adminSlice';
import SpinnerLoader from './component/Loader/Loader';
import routes from './router/routes.js';
import { HttpListClient } from './utils/HttpClient';
import Swal from 'sweetalert2';

/**
 * @component
 * The main functional component which bootstraps the app,
 * takes care of the main layout and components to render
 * fetches the Stations from the api before mounts and saves it in store.
 * @returns {App}
 */
function App() {
  let location = useLocation();
  const dispatch = useDispatch();
  const [fullScreenLogin, setFullScreenLogin] = useState(false);

  const favouriteStorage = localForage.createInstance({
    name: 'favorites',
  });

  const { isLoggedIn, isLoading } = useSelector((state) => state.admin);

  const getStationsFromApi = async () => {
    let res;
    try {
      let { data } = await HttpListClient.get('/getStations');
      let provinceData = await HttpListClient.get('/getProvinces');
      res = JSON.parse(atob(data)) ?? [];

      setImmediate(() => {
        dispatch(getStations(res));
        dispatch(setProvince(provinceData.data));
      });
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Parece haber un problema con la conexion por favor intente mas tarde.',
        icon: 'warning',
        iconColor: '#FFD732',
        confirmButtonColor: '#003876',
      });
      await dispatch(getStations([]));
    }
  };

  useEffect(() => {
    getStationsFromApi();
  }, []);

  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];
    currentPathName.includes('login')
      ? setFullScreenLogin(true)
      : setFullScreenLogin(false);
  }, [location]);

  useEffect(async () => {
    let favs = (await favouriteStorage.getItem('favs')) ?? [];
    dispatch(setFavorites(favs));
  }, [location]);

  return (
    <>
      <Container>
        <SidebarContent style={{ width: fullScreenLogin ? '100%' : '' }} />
        <Content
          style={{ width: fullScreenLogin ? '100%' : '' }}
          onClick={() => dispatch(setMenuOpenedState(false))}>
          {isLoading ? <SpinnerLoader /> : null}
          <NavbarContent />
          <Switch>
            <Route path={routes.home} exact component={Home} />
            <Route path={routes.favorites} exact component={Favourites} />
            <Route path={routes.terms} exact component={Terms} />
            <Route path={routes.privacy} exact component={Privacy} />
            <Route path={routes.about} exact component={About} />
            <Route path={routes.login} exact component={Login} />
            <GuardedRoute
              path={routes.admin}
              component={Gestion}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.addStation}
              component={Add}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.editStation}
              component={Edit}
              auth={isLoggedIn}
            />

            <GuardedRoute
              path={routes.manualPage1}
              component={ManualUsuario}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.manualPage2}
              component={ManualUsuario1}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.manualPage3}
              component={ManualUsuario2}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.manualPage4}
              component={ManualUsuario3}
              auth={isLoggedIn}
            />
            <GuardedRoute
              path={routes.manualPage5}
              component={ManualUsuario4}
              auth={isLoggedIn}
            />
            <Route path="/" exact>
              <Redirect to={routes.home} />
            </Route>
            <Route>
              <Redirect to={routes.home} />
            </Route>
          </Switch>
        </Content>
        <PlayerBarContainer />
      </Container>
    </>
  );
}

export default App;
